import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=31669bed&scoped=true"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/shared-admin-styles.css?vue&type=style&index=0&id=31669bed&prod&scoped=true&lang=css&external"
import style1 from "./Faq.vue?vue&type=style&index=1&id=31669bed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31669bed",
  null
  
)

export default component.exports